import React from 'react';

const Navigation = () => {
	return (
		<nav className="navbar navbar-expand-lg navbar-dark bg-primary">
		  <a className="navbar-brand" href="#">Project Mars</a>
		</nav>
	);
} 

export default Navigation;
